// Permission constants — mirror of the sibling mdg-frontend repo's
// `src/constants/permission.js`. Two exports:
//
//   MODULES      — kebab-case module ids (re-exported from MODULE_NAME
//                  for naming parity; both names point at the same map).
//   PERMISSIONS  — action verbs a role can perform on a module. Lowercase
//                  so a backend payload like `permission: 'view'`
//                  (or 'read' / 'update') resolves consistently across
//                  role definitions.
//
// Codes that already use `MODULE_NAME` keep working — both names point
// at the same kebab-case registry.

import { MODULE_NAME } from './modules'

export const MODULES = MODULE_NAME

export const PERMISSIONS = Object.freeze({
  VIEW: 'view',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  UPLOAD: 'upload',
})
